import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

type DashboardLayoutProps = {
  header?: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
};

const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
  return (
    <div
      className="dashboard-layout"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh"
      }}
    >
      {/* Header */}
      <div className="dashboard-header">
        <Header />
      </div>

      <div
        className="dashboard-main"
        style={{ flex: 1 }}
      >
        <Outlet />
      </div>

      {/* Footer always at bottom */}
      <div className="dashboard-footer">
        <Footer />
      </div>
    </div>
  );
};

export default DashboardLayout;
